module.exports = __webpack_public_path__ + "static/media/cifras_1.062b978f.png";